/*
 * @Description: 
 * @Autor: jyf
 * @Date: 2020-11-16 09:13:40
 * @LastEditors: jyf
 * @LastEditTime: 2020-11-26 01:34:59
 */
import Vue from 'vue';
import Vuex from 'vuex';
import app from './modules/app';
import login from './modules/login';


// import { asyncRouterMap, asyncRouterMaps } from '../router/index';
Vue.use(Vuex);

const store = new Vuex.Store({
    state: {
        ossBucket: '',//ali-oss
        asyncRouterMap: [],
        headUrl: localStorage.getItem("img"),
    },
    mutations: {
        judgeDomain: (state, data) => {
            if (process.env.NODE_ENV==='production') {
                state.ossBucket = "sinostorage"
            } else {
                state.ossBucket = "sinostoragedev"
            }

        },
   
    },
    actions: {

    },
    modules: {
        app,
        login,
    }
});

export default store;



// WEBPACK FOOTER //
// ./src/vuex/index.ts